var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.registerStep === 0)?_c('Register',{on:{"changeRegisterStep":_vm.changeRegisterStep}}):_c('Register2')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }